import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedSlaNewRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-sla-new',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/sla/new',
	exact: true,
};
